import { createContext } from "react";
import { IMillDashboardsContext } from "./MillDashboardsContextInterfaces";
import { getFirstDayOfTheMonthAtZeroHour, getTodayAtEndOfDay } from "utilities/utilities";
import { DisplayInOptionsEnum } from "constants/constants";

const firstDayOfTheMonth = getFirstDayOfTheMonthAtZeroHour();
const today = getTodayAtEndOfDay();

export const initialState: IMillDashboardsContext = {
    showDetails: false,
    showOnlyPending: true,
    showOrHideDetails: () => {},
    showOrHideOnlyPending: () => {},
    displayUnit: DisplayInOptionsEnum.MINUTES,
    handleChangeDisplayUnit: () => {},
    topHeaderArea: null,
    handleSetTopHeaderArea: () => {},
    reportRangeStartDate: firstDayOfTheMonth,
    reportRangeEndDate: today,
    handleSetReportRangeStartDate: () => {},
    handleSetReportRangeEndDate: () => {},
    pendingEventReportsCount: 0,
    setPendingEventReportsCount: () => {},
    refreshPendingEventReportsCount: () => {},
};

export const MillDashboardContext = createContext(initialState);
